import React from 'react';

const SvgComponent = (props) => (
  <svg viewBox="0 0 18 18" width="1em" height="1em" {...props}>
    <path d="M17.508 1.233l-.741-.741a1.68 1.68 0 0 0-2.375 0L6.298 8.587 4 14l5.413-2.298 8.095-8.095a1.678 1.678 0 0 0 0-2.374zm-7.24 11.736l-.269.114-5.413 2.298-3.417 1.451 1.451-3.417 2.298-5.413.114-.269.206-.206L11.764 1H0v17h16V7.236l-5.526 5.526-.206.207z" />
  </svg>
);

export default SvgComponent;
